var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[_c('app-header'),_vm._v(" "),_c('main',{staticClass:"appLayoutContent",class:_vm.$style.content},[(!_vm.settings.noBanner)?_c('lazy-app-banner'):_vm._e(),_vm._v(" "),_c('div',{class:[_vm.$style.inner, {
        [_vm.$style.innerPadding]: !_vm.settings.noPadding,
      }]},[_vm._t("default")],2)],1),_vm._v(" "),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }